import React, {useContext, useState} from "react";
import {BrowserView,isMobile, MobileView} from 'react-device-detect';
import { Rating } from 'react-simple-star-rating';
import { AppContext, UserContext } from "../../AppContextProvider";
import {ButtonLoader} from "../utils/ButtonLoader";
import {useFetch} from "../api/FetchApiData";
import { MediaUrl } from "../utils/Media";
import { useNavigate } from "react-router-dom";
import km_flag from './icons/km_flag.svg';
import tr_flag from './icons/tr_flag.png';
import fr_flag from './icons/fr_flag.png';
import sa_flag from './icons/sa_flag.jpg';

if (isMobile)
    import('./vitrine_mob.css').then(() => {});
else
    import('./vitrine.css').then(() => {});

export default function Vitrine(props)
{
    const [loading,setLoading] = useState(false);
    const [UserState,setUserState] = useContext(UserContext);
    const navigator = useNavigate();
    const fetchData = useFetch();
    let itemTitle = props.article.title;


    if(itemTitle.length>45)
    {
        itemTitle = itemTitle.substring(0,45)+' ...'
    }

    const UpdatePanier = async (panier)=>
    {
        setLoading(true);
        let _panier = {id:panier.id, articles:[]};
        panier.articles.forEach((item) => {
            _panier.articles.push({id:item.id,quantite:item.quantite})
        });
        fetchData.PutData(_panier, 'panier/').then((result)=>{
            if(result.result)
            {setLoading(false);setUserState({...UserState,panier:result.panier});}
        })
        
    }

    const AddToPanier = ()=>
    {
        let _data = {}
        const found = UserState.panier.articles.find((element) => element.article.id === props.article.id);
        if(found!==undefined)
        {
            _data = {id:found.id, 
                quantity:typeof(found.quantity)==='string' ? parseInt(found.quantity)+1 : found.quantity+1,
            }            
        }
        else{
            _data = {article:{id:props.article.id},quantity:1};             
            //_UserState.panier.articles.push(_art);
        }

        if(UserState.auth)
        {
            fetchData.PostData(_data,'panier/item/').then((result)=>
                {
                    if(result.result)
                    {
                        setUserState({...UserState,panier:result.panier}); 
                }});
        }
        else
        {
            let _UserState = UserState;
            if(found!==undefined)
            {
                let index = _UserState.panier.articles.indexOf(found);
                found.quantity = typeof(found.quantity)==='string' ? parseInt(found.quantity)+1 : found.quantity+1;
                found.article = {title:props.article.title,id:props.article.id,image:props.article.image};
                _UserState.panier.articles[index] = found;

            }
            else
            {
                let _art = {article:{title:props.article.title,id:props.article.id,image:props.article.image},quantity:1};             
                _UserState.panier.articles.push(_art);
            }   
            setUserState({...UserState,panier:_UserState.panier});
        }
        /*
        const imgsrc = "";
        try
        {imgsrc = MediaUrl(props.article.image);}
        catch{}
        const found = UserState.panier.articles.find((element) => element.id === props.article.id);
        var panier = UserState.panier;
        if(found!==undefined)
        {
            let index = UserState.panier.articles.indexOf(found);
            found.quantite = typeof(found.quantite)==='string' ? parseInt(found.quantite)+1 : found.quantite+1; 
            panier.articles[index] = found;
        }
        else{
            panier.articles.push({title:props.article.title,id:props.article.id,quantite:1,price:props.article.price,delivry:0,image:props.article.image});
        }
        if(UserState.auth)
            UpdatePanier(panier);
        else
            setUserState({...UserState,panier:panier})
        */
    }

    const PriceSticker = ()=>
    {
        if(props.article.promo===null)
            return(
                <div className="SpanPrice" style={{fontWeight:'bold'}}>
                    <span>{props.article.price} €</span>
                </div>
            )
        else
        {
            let new_price = props.article.price - ((props.article.price*props.article.promo.reduction)/100);
            return(
                <div className="SpanPrice" style={{}}>
                    <span style={{textDecoration:'line-through'}}>{props.article.price} €</span>
                    <span style={{color:'red'}}><b>-{props.article.promo.reduction}% : {new_price} €</b></span>
                </div>
            )
        }
    }

    let flag_from = km_flag;
    if(props.article.delivery_from==='France')
        flag_from = fr_flag;
    else if(props.article.delivery_from==='Turquie')
        flag_from = tr_flag;
    else if(props.article.delivery_from==='Arabie Saoudite')
        flag_from = sa_flag;


    return(
        <div id="Vitrine">
            <BrowserView>
                    <div id="image" onClick={e=>{navigator('/product/'+props.article.id)}}>
                        {PriceSticker()}
                        <img style={{margin:'auto'}} src={MediaUrl(props.article.image)} /> 
                    </div>
                    <div id="infos">
                        <h5 style={{paddingRight:'10px',paddingLeft:'10px'}}>{itemTitle}</h5>
                        <div className="rating" style={{marginTop:'5px'}}>
                            <Rating size={20} readonly={true} initialValue={props.article.note} onClick={e=>{}} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} />
                        </div>
                        <span style={{color:'green'}}>{props.article.stock} en stock <img className="flag" src={flag_from} /></span>
                    </div>
                    <div id="btnAchat"><ButtonLoader onSubmit={e=>{AddToPanier();}} style={{backGroundColor:'gold',fontSize:'small'}} loading={loading} text={"Acheter"} /></div>
            </BrowserView>
            <MobileView>
                {PriceSticker()}
                <div id="image" onClick={e=>{navigator('/product/'+props.article.id)}}>
                    <img src={MediaUrl(props.article.image)} /> 
                </div>
                <div id="infos">
                    <div className="title">
                        <label>{itemTitle}</label>
                    </div>
                    <div className="rating">
                        <Rating size={20} onClick={e=>{}} readonly={true} initialValue={2.5} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} />
                    </div>
                    <div className="stock">
                        <span style={{color:'green'}}>{props.article.stock} en stock <img className="flag" src={fr_flag} /></span>
                        <br/>
                        <span style={{color:'violet',fontSize:'x-small'}}>Delaie de livraison : 3 jours</span>
                    </div>
                    {(!!props.article.relative_error.relatif_errors) &&
                        <div className="stock">
                            {props.article.relative_error.relatif_errors.map((err)=>{
                                <span style={{color:'green'}}>Erreur relatif ({err[0]}) : {err[1]}</span>
                                })
                            }
                        </div>
                    }
                    <div id="btnAchat"><ButtonLoader onSubmit={e=>{AddToPanier();}} style={{backGroundColor:'gold',fontSize:'small'}} loading={loading} text={"Acheter"} /></div>
                </div>
            </MobileView>
        </div>
    );
}